<script setup lang="ts">
  import PlaceholderShimmer from '@/components/common/PlaceholderShimmer.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import CourseDetailsActionLoader from '@/components/loaders/CourseDetailsActionLoader.vue'

  import useBreakpoint from '@/composables/useBreakpoint'

  const { isSmallerMobileDevice } = useBreakpoint()
</script>

<template lang="pug">
.course-panel-loader
  LoadingSpinner.ketch-py-c30(v-if='isSmallerMobileDevice')
  template(v-else)
    .course-overview-wrapper
      .course-overview
        .course-teaser-image
          PlaceholderShimmer(animate, height='160px', width='100%')
        .course-exam-sector
          PlaceholderShimmer(animate, height='45px', width='65%')
        .course-type-toggle
          .course-type
            PlaceholderShimmer(animate, height='45px')
          .course-type
            PlaceholderShimmer(animate, height='45px')
      .lesson-progress
        .your-progress
          PlaceholderShimmer(animate, height='15px', width='100px')
        .progress-bar
          PlaceholderShimmer(animate, height='30px')
      CourseDetailsActionLoader
    .exam-webinar-details
      PlaceholderShimmer(animate, height='100%', width='100%')
</template>

<style lang="postcss" scoped>
  .course-panel-loader {
    @apply ketch-shadow-content-shadow ketch-bg-content-background-color ketch-p-c20 ketch-rounded-normal;
    @apply sm:ketch-grid sm:ketch-grid-cols-2 sm:ketch-gap-c20 sm:ketch-rounded-large;

    .course-overview-wrapper {
      @apply ketch-flex ketch-flex-col ketch-space-y-c20;

      .course-overview {
        @apply ketch-flex ketch-flex-col ketch-space-y-c15;

        .course-type-toggle {
          @apply ketch-flex ketch-flex-row ketch-space-x-c10;

          .course-type {
            @apply ketch-flex-1;
          }
        }
      }

      .lesson-progress {
        @apply ketch-flex ketch-flex-col ketch-space-y-c10;
      }

      .course-details-action {
        @apply ketch-flex ketch-flex-col ketch-space-y-c10;
      }
    }
  }
</style>
